import useCursorGlow from "../../hooks/useCursorGlow";

const CursorGlow = () => {
  const glowRef = useCursorGlow();

  return <div ref={glowRef} className="cursor-glow" aria-hidden="true" />;
};

export default CursorGlow;
